<template>
  <div>
    editing room {{$route.params.id}}
  </div>
</template>

<script>
export default {
  name: 'RoomEditView',
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/RoomEditView.vue